'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.ui-components.cbSectionCloserController', []);

_module.controller('cbSectionCloserController', cbSectionCloserController);

exports.default = _module;


function cbSectionCloserController() {
    var vm = this;

    vm.hidden = false;

    /**
     * @description Inverts vm.visible from true to false
     */
    vm.close = function () {
        vm.hidden = !vm.hidden;
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/section-closer/cb-section-closer.controller.js
// module id = 897
// module chunks = 0